import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {CompanyTaxDistribution} from "../helpers/constants";

@Injectable({
  providedIn: 'root'
})

export class TaxService {

  constructor() {
  }

  hideTaxes(taxDistributionType: number, companyId: number) {
    return taxDistributionType === CompanyTaxDistribution.EMPLOYEE_SALARY && environment.taxManagement && environment.taxManagement.hideTaxesFor && environment.taxManagement.hideTaxesFor.length > 0 && environment.taxManagement.hideTaxesFor.includes(companyId);
  }

  getTotalTaxAmount(taxModel: {
    employeeTaxValue?: number;
    companyTaxValue?: number;
    camTaxValue?: number;
  } | null | undefined): number {
    if (!taxModel) {
      return 0;
    }

    return (taxModel.employeeTaxValue ?? 0) + (taxModel.companyTaxValue ?? 0) + (taxModel.camTaxValue ?? 0);
  }

  getTotalTaxAmountWithoutCAM(taxModel: {
    employeeTaxValue?: number;
    companyTaxValue?: number;
  } | null | undefined): number {
    if (!taxModel) {
      return 0;
    }

    return (taxModel.employeeTaxValue ?? 0) + (taxModel.companyTaxValue ?? 0);
  }

  getTotalOrderTaxAmount(orderDetails: {
    taxEmployee?: number;
    taxCompany?: number;
    camTax?: number;
  } | null | undefined, companyTaxDistribution?: CompanyTaxDistribution | number | null): number {
    if (!orderDetails) {
      return 0;
    }

    if (companyTaxDistribution == null) {
      return (orderDetails.taxEmployee ?? 0) + (orderDetails.taxCompany ?? 0) + (orderDetails.camTax ?? 0);
    }

    const employeeTaxAmount = companyTaxDistribution === CompanyTaxDistribution.EMPLOYEE ? (orderDetails.taxEmployee ?? 0) : 0;
    const camTaxAmount =
      companyTaxDistribution === CompanyTaxDistribution.EMPLOYEE ||
      companyTaxDistribution === CompanyTaxDistribution.EMPLOYEE_SALARY
        ? (orderDetails.camTax ?? 0)
        : 0;

    return (orderDetails.taxCompany ?? 0) + employeeTaxAmount + camTaxAmount;
  }

  getAmountWithCam(amount: number | null | undefined, camTax: number | null | undefined): number {
    return (amount ?? 0) + (camTax ?? 0);
  }

  getAmountToPayFromBenefitTaxes(
    benefitTaxes: {
      amountWithVat?: number;
      employeeTaxValue?: number;
      camTaxValue?: number;
    } | null | undefined,
    companyTaxDistribution: CompanyTaxDistribution | number | null | undefined
  ): number {
    const amountWithCam = this.getAmountWithCam(benefitTaxes?.amountWithVat, benefitTaxes?.camTaxValue);
    return companyTaxDistribution === CompanyTaxDistribution.EMPLOYEE
      ? amountWithCam + (benefitTaxes?.employeeTaxValue ?? 0)
      : amountWithCam;
  }

  getAmountToPayFromOrderDetails(
    orderDetails: {
      amountWithVAT?: number;
      taxEmployee?: number;
      camTax?: number;
    } | null | undefined,
    companyTaxDistribution: CompanyTaxDistribution | number | null | undefined
  ): number {
    const camTaxAmount =
      companyTaxDistribution === CompanyTaxDistribution.EMPLOYEE ||
      companyTaxDistribution === CompanyTaxDistribution.EMPLOYEE_SALARY
        ? (orderDetails?.camTax ?? 0)
        : 0;
    const amountWithCam = this.getAmountWithCam(orderDetails?.amountWithVAT, camTaxAmount);
    return companyTaxDistribution === CompanyTaxDistribution.EMPLOYEE
      ? amountWithCam + (orderDetails?.taxEmployee ?? 0)
      : amountWithCam;
  }

  getTotalOrderAmountForDisplay(
    orderDetails: {
      amountWithVAT?: number;
      taxEmployee?: number;
      taxCompany?: number;
      camTax?: number;
    } | null | undefined,
    companyTaxDistribution: CompanyTaxDistribution | number | null | undefined
  ): number {
    return (orderDetails?.amountWithVAT ?? 0) + this.getTotalOrderTaxAmount(orderDetails, companyTaxDistribution);
  }
}
